{
  "helpMessage": "<p>Mēnā kei te raru koe, waea mai ki <a><strong>{{phone}}</strong></a> (ka pēhi i te <strong>Kōwhiringa 2</strong>).</p>",
  "noCode": "Kāore koe i whiwhi i te waehere?",
  "remainingTime": "E toe ana te {{time}}",
  "sendCode": "Tukua he waehere hou",
  "text": "<p>Kua tukua e mātou he waehere 4-mati ki tō nama waea pūkoro: <strong><PhonePlaceholder /></strong></p>\n<p>He whaimana te waehere mō te {{validityMinutes}} meneti.</p>\n<p>Tāurua te waehere ki raro nei kia haere tonu.</p>",
  "title": "Tāurua tō waehere"
}
